import { useCallback, useEffect, useState } from 'react';

import { parentalControlsHelper } from '../../helpers/parentalControls';
import { useWorkflow } from '../utils/useWorkflow';

import { useParentalControls } from './shared/useParentalControls';
import { workflow } from './ParentalControls.workflow';
import { ParentalControlsView } from './ParentalControlsView';

import type { FC } from 'react';

interface ParentalControlProps {
  onUnlockClick?: () => void;
}

const ParentalControls: FC<ParentalControlProps> = () => {
  const { parentalControlsManagerVisible, hideParentalControlsManager } =
    useParentalControls();
  const { state, apply } = useWorkflow(workflow, 'closed');

  const [activationCode, setActivationCode] = useState<string>();
  const [ageLimit, setAgeLimit] = useState<number>();

  useEffect(() => {
    if (parentalControlsManagerVisible) {
      if (parentalControlsHelper.isParentalLockSet()) {
        apply('openLocked');
      } else {
        apply('open');
      }
    } else {
      if (state !== 'closed') {
        apply('close');
      }
    }
  }, [apply, parentalControlsManagerVisible]);

  const onLockChosen = useCallback((pinCode?: string, ageLimit?: number) => {
    setActivationCode(pinCode);
    setAgeLimit(ageLimit);
  }, []);

  const onConfirmation = useCallback(() => {
    if (ageLimit && activationCode) {
      parentalControlsHelper.setParentalLock(ageLimit, activationCode);
    }
  }, [activationCode, ageLimit]);

  const handleClose = useCallback(() => {
    apply('close');
    hideParentalControlsManager();
  }, [apply, hideParentalControlsManager]);

  const handleDisable = useCallback(() => {
    parentalControlsHelper.removeParentalLock();
    apply('removed-code');
  }, [apply]);

  const handleUnlock = useCallback(() => {
    apply('remove-code');
  }, [apply]);

  const handleLock = useCallback(
    (pinCode, ageLimit) => {
      apply('set-code');
      onLockChosen(pinCode, ageLimit);
    },
    [apply, onLockChosen]
  );

  const handleValidate = useCallback(() => {
    apply('confirm-code');
    onConfirmation();
  }, [apply, onConfirmation]);

  return (
    <ParentalControlsView
      activationCode={activationCode}
      state={state}
      handleClose={handleClose}
      handleDisable={handleDisable}
      handleValidate={handleValidate}
      handleLock={handleLock}
      handleUnlock={handleUnlock}
    />
  );
};

export { ParentalControls };
